import { Flex, IconButton, Text } from "@chakra-ui/react";
import { RepeatIcon } from "@chakra-ui/icons";
import { memo } from "react";

type Props = {
  clientId: string;
  onRetrySend: (clientId: string) => void;
};

export const MessageFailedStatus = memo(function MessageFailedStatus({ clientId, onRetrySend }: Props) {
  return (
    <Flex align="center" justify="flex-end" gap="8px" mb="6px">
      <Text fontSize="12px" color="#E53E3E">
        Not sent
      </Text>
      <IconButton
        aria-label="Retry send"
        icon={<RepeatIcon />}
        variant="ghost"
        size="xs"
        color="#E53E3E"
        _hover={{ bg: "transparent" }}
        _active={{ bg: "transparent" }}
        _focus={{ boxShadow: "none" }}
        onClick={() => onRetrySend(clientId)}
      />
    </Flex>
  );
});
